/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { gql } from '@apollo/client';
export type CmPictureFragment = { __typename?: 'CMPictureImpl', id: string, title?: string | null, name: string, alt?: string | null, uriTemplate: string, type: string, copyright?: string | null, mediaSettings?: any | null, storytellingSettings?: any | null, teaserText?: { __typename?: 'RichText', textAsTree?: any | null, text?: string | null } | null, detailText?: { __typename?: 'RichText', textAsTree?: any | null, text?: string | null } | null, data?: { __typename?: 'Blob', uri?: string | null } | null };

export const CmPictureFragmentDoc = gql`
    fragment CMPicture on CMPicture {
  id
  title
  teaserText {
    textAsTree
    text
  }
  detailText {
    textAsTree
    text
  }
  name
  data {
    uri
  }
  alt
  uriTemplate
  type
  copyright
  mediaSettings: settings(paths: ["disableCropping", "positionForStageteaser"])
  storytellingSettings: settings(
    paths: ["storytelling.title.length", "storytelling.text.length", "quote.text.length"]
  )
}
    `;